export const ENDPOINT = {
    "notify": {
        "api": "https://notify-api.line.me/api",
        "oauth": "https://notify-bot.line.me/oauth"
    }
};
//# sourceMappingURL=consts.js.map